import { useEffect } from 'react';
import { qontoWebsocket } from './websocket';

interface UseQontoWebsocketConnectionOptions {
  websocketBaseURL: string;
  token: string;
  userId: string;
  onError?: (error: unknown) => void;
}

/**
 * Establishes a WebSocket connection using qontoWebsocket.connect().
 * The connection is automatically disconnected when the component unmounts.
 *
 * This hook should be used in applications where the WebSocket
 * connection is not already globally established.
 *
 */
export function useQontoWebsocketConnection({
  websocketBaseURL,
  token,
  userId,
  onError,
}: UseQontoWebsocketConnectionOptions) {
  useEffect(() => {
    if (!token || !userId) return;

    try {
      qontoWebsocket.connect({
        websocketBaseURL,
        token,
        userId,
      });
    } catch (error) {
      onError?.(error);
    }

    return () => {
      qontoWebsocket.disconnect();
    };
  }, [websocketBaseURL, token, userId, onError]);
}
